import Image from '../../components/images/Image';

const logo_path = 'ghg_small_logo_highlight.svg';

export default function Logo () {
    return (
        <Image styles={{ width: '51px' }} src={logo_path} />
    )
}